import React, { useContext } from 'react'
import EditPartAction from './EditPartAction/EditPartAction'
import EditProjectIdAction from './EditProjectIdAction/EditProjectIdAction'
import EditTypeAction from './EditTypeAction/EditTypeAction'
import EditCategoryAction from './EditCategoryAction/EditCategoryAction'
import EditRevisionAction from './EditRevisionAction/EditRevisionAction'
import HeadingText from '../ActionCommonComponent/HeadingText'
import EditTaskAction from './EditTaskAction/EditTaskAction'
import EditSuggestionRuleAction from './EditSuggestionRuleAction/EditSuggestionRuleAction'

import { useS3Data } from '../../../../hooks/useS3Data'

const EditFromPopupAction = ({data}) => {
  
  const { data: s3PrevData } = useS3Data(data?.parent_version_data.new_content_snapshot)
  const { data: s3NewData } = useS3Data(data?.new_content_snapshot)

  const prevData = s3PrevData || data?.parent_version_data?.version_content
  const newData = s3NewData || data?.version_content
  const action_to_show = data?.version_content?.action_to_show
  
  return (
    <>  <HeadingText heading="Activity" text={data?.action}/>
        {action_to_show === "UPDATE_PART" && <EditPartAction prevData={prevData} newData={newData}/>}
        {action_to_show === "UPDATE_TYPE" && <EditTypeAction prevData={prevData} newData={newData}/>}
        {action_to_show === "UPDATE_PROJECT_ID" && <EditProjectIdAction prevData={prevData} newData={newData}/>}
        {action_to_show === "UPDATE_CATEGORY" && <EditCategoryAction prevData={prevData} newData={newData}/>}
        {action_to_show === "UPDATE_PROCEDURE_REVISION" && <EditRevisionAction data={data}/>}
        {action_to_show === "UPDATE_TASK" && <EditTaskAction newData={newData}/>}
        {action_to_show === "UPDATE_SUGGESTION_RULE" && <EditSuggestionRuleAction prevData={{
          ...prevData,
          match_count:data?.parent_version_data?.version_content?.match_count
        }} newData={{
          ...newData,
          match_count:data?.version_content?.match_count
        }}/>}
    </>
  )
}

export default EditFromPopupAction